<button
  [ngClass]="[buttonClass || '', buttonStyle, color]"
  [type]="type"
  (click)="buttonClick.emit()"
  [disabled]="disabled">
    <span class="primary-button-text-value">{{text | translate | appFirstLetterUppercase}}</span>
</button>
